import React from 'react';
import { usePlanningBottomupState } from '../Context/index';

export function UnitCostGlobal() {
  const { planningBottomup, checkVisibleBottomUp } = usePlanningBottomupState();
  const { planningBottomProducts, selectedDisplayColumn } = planningBottomup;
  const UnitCostGlobalFields = [
    {
      keyName: 'unitsGlobal',
      name: 'Units Global',
    },
    // {
    //   keyName: "costGlobal",
    //   name: "Cost Global",
    // },
  ];
  const isTableVisible = UnitCostGlobalFields.filter((ele) => selectedDisplayColumn?.includes(ele.keyName));
  return (
    isTableVisible.length > 0 && (
      <table className="table custom-table layout-fixed planning-actual-tbl font-13 mr-3">
        <thead>
          <tr>
            {UnitCostGlobalFields?.map((UnitCostItem, i) => {
              const isVisible = checkVisibleBottomUp(UnitCostItem.keyName);
              return (
                isVisible && (
                  <th key={i} className="w-200px">
                    <span>{UnitCostItem?.name}</span>
                  </th>
                )
              );
            })}
          </tr>
        </thead>
        <tbody>
          {(planningBottomProducts ?? [])?.map((trItem, iParent) => {
            return (
              <tr key={iParent}>
                {UnitCostGlobalFields?.map((tdItem, iTD) => {
                  const isVisible = checkVisibleBottomUp(tdItem.keyName);
                  return (
                    isVisible && (
                      <td key={iTD} className="text-right">
                        {trItem[tdItem.keyName]}
                      </td>
                    )
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    )
  );
}
export default UnitCostGlobal;
